export default __webpack_public_path__ + "static/media/intake-icon.b29f9ec9.svg";